// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6582":"ed60d3bd","7268":"f2f61c69"}[chunkId] + ".chunk.css";
};